var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fields-list',{attrs:{"fields":_vm.fields,"editing-data":_vm.editingData},on:{"update-field":function($event){return _vm.updateField($event.value, $event.field)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec73691","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsCabinet.vue
// module id = null
// module chunks = 